export const FAMILY_MEMBER_ID_NAME = 'memberId';
export const OTHER = 'other';
export const RECURRING = 'recurring';

// field names
export const STRENGTH_FIELD_NAME = 'strength';
export const FILL_QUANTITY_FIELD_NAME = 'fillQty';
export const OTHER_FILL_QUANTITY_FIELD_NAME = 'otherFillQty';
export const PRESCRIPTION_DURATION_FIELD_NAME = 'durationDays';
export const OTHER_PRESCRIPTION_DURATION_FIELD_NAME = 'otherDurationDays';
export const FILL_COUNT_FIELD_NAME = 'fillCount';
export const OTHER_FILL_COUNT_FIELD_NAME = 'otherFillCount';
